<template>
    <div class="main-Wrapper" style="position: relative;">
        <div class="page-wrapper">
            <div class="content container-fluid" style="min-height: 92vh;">

                <div>
                    <div class="d-flex justify-content-center flex-wrap mb-4">
                        <div style="width: 380px;" v-for="(item, i) in UBNDData" :key="'ubnd-' + i">
                            <a :href="item.URL" target="_blank" style="color: #fff; width: 100%;">
                                <div class="card-lich d-flex">
                                    <div class="corner">
                                        <i data-corner="tl"></i>
                                        <i data-corner="br"></i>
                                        <div class="corner-icon">
                                            <svg viewBox="0 0 61.7998 61.7998" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="30.9" cy="30.9" r="20" fill="#fff" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="boxes">
                                        <span class="img">
                                            <img src="@/assets/img/logo/logo.png" alt="">
                                        </span>
                                        <span style="position: relative; width: 100%;">
                                            <p class="name">{{ item.Name }}</p>
                                            <p class="caption">
                                                <span>
                                                    <i class="fa fa-solid fa-location-dot me-1"
                                                        style="color: #3cb54a;"></i>{{ item.Address }}
                                                </span>
                                            </p>
                                        </span>
                                    </div>
                                    <div class="lotus">
                                        <img src="@/assets/img/core/lotus.png" alt="">
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="card-search-wrapper p-2 mb-4">
                        <input v-model="searchQuery" type="text" class="form-control search-input pt-2 pb-2"
                            placeholder="Tìm kiếm theo tên, tên không dấu hoặc địa chỉ web..." />
                        <div class="nav nav-pills pt-2 pb-2 d-flex" style="flex-wrap: nowrap; justify-content: center;">
                            <div class="nav-item" v-for="tab in tabs" :key="tab.key">
                                <button class="nav-link me-2" :class="{ active: activeTab === tab.key }"
                                    @click="changeTab(tab.key)">
                                    {{ tab.label }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="activeTab === 'sbn'">
                        <div class="grid-wrapper-so grid-cols-5 card-xa-phuong">
                            <div class="grid-item" v-for="(item, i) in pagedData" :key="'sbn-item-' + i">
                                <a :href="item.URL" target="_blank" style="color: #fff; width: 100%;">
                                    <div class="card-lich d-flex">
                                        <div class="corner">
                                            <i data-corner="tl"></i>
                                            <i data-corner="br"></i>
                                            <div class="corner-icon">
                                                <svg viewBox="0 0 61.7998 61.7998" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="30.9" cy="30.9" r="20" fill="#fff" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="boxes">
                                            <span class="img">
                                                <img src="@/assets/img/logo/logo.png" alt="">
                                            </span>
                                            <span style="position: relative; width: 100%;">
                                                <p class="name">{{ item.Name }}</p>
                                                <p class="caption">
                                                    <span>
                                                        <i class="fa fa-solid fa-location-dot me-1"
                                                            style="color: #3cb54a;"></i>{{ item.Address }}
                                                    </span>
                                                </p>
                                            </span>
                                        </div>
                                        <div class="lotus">
                                            <img src="@/assets/img/core/lotus.png" alt="">
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div v-if="activeTab === 'xa'">
                        <div class="grid-wrapper-xa grid-cols-6 card-xa-phuong">
                            <div class="grid-item" v-for="(item, i) in pagedData" :key="'xa-item-' + i">
                                <a :href="item.URL" target="_blank" style="color: #fff; width: 100%;">
                                    <div class="card-lich d-flex">
                                        <div class="corner">
                                            <i data-corner="tl"></i>
                                            <i data-corner="br"></i>
                                            <div class="corner-icon">
                                                <svg viewBox="0 0 61.7998 61.7998" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="30.9" cy="30.9" r="20" fill="#fff" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="boxes">
                                            <span class="img">
                                                <img src="@/assets/img/logo/logo.png" alt="">
                                            </span>
                                            <span style="position: relative; width: 100%;">
                                                <p class="name-xa">{{ item.Name }}</p>
                                                <p class="caption-xa">
                                                    <span>
                                                        <i class="fa fa-solid fa-location-dot me-1"
                                                            style="color: #3cb54a;"></i>{{ item.Address }}
                                                    </span>
                                                </p>
                                            </span>
                                        </div>
                                        <div class="lotus">
                                            <img src="@/assets/img/core/lotus.png" alt="">
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row fix-row p-2">
                        <div class="col-md-6 col-sm-6 mt-2">
                            <div>
                                Hiển thị
                                <label class="d-inline-flex align-items-center">
                                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                                        :options="pageOptions"
                                        style="width: 70px; text-align: center;"></b-form-select>&nbsp;
                                </label>
                                trên tổng số {{ totalRows }} dòng
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 mt-2 pagination dashboard-pagination">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="" style="position: absolute; bottom: 5vh; z-index: -1; opacity: 0.2;">
            <img src="@/assets/img/core/banner.png" alt="" style="width: 100%; height: 100%; ">
        </div>

        <adminfooter></adminfooter>
    </div>
</template>
<script>
import { tabs as tabList } from '../lichHop/tab.js';
import { Data } from '../lichHop/data.js';

export default {
    components: {

    },
    data() {
        return {
            tabs: tabList, //
            activeTab: tabList[0].key, //
            tabData: {},
            searchQuery: '',
            UBNDData: [],
            currentPage: 1,
            perPage: 36,
            pageOptions: [36, 72, 102],
        }
    },
    computed: {
        // Lấy dữ liệu đã được lọc dựa trên tab và từ khóa tìm kiếm
        displayedData() {
            const raw = this.tabData[this.activeTab] || [];
            return this.filterData(raw);
        },
        // Tổng số dòng của dữ liệu đã lọc
        totalRows() {
            return this.displayedData.length;
        },
        // Dữ liệu hiển thị trên trang hiện tại
        pagedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.displayedData.slice(start, end);
        }
    },
    methods: {
        // Hàm bỏ dấu tiếng Việt
        removeVietnameseTones(str) {
            return str
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/đ/g, 'd')
                .replace(/Đ/g, 'D')
                .toLowerCase();
        },
        // Hàm lọc dữ liệu dựa trên searchQuery
        filterData(list) {
            const q = this.removeVietnameseTones(this.searchQuery.trim().toLowerCase())
            if (!q) return list

            return list.filter((item) => {
                const name = item.Name?.toLowerCase() || ''
                const unsigned = item.UnsignedName?.toLowerCase() || ''
                const url = item.URL?.toLowerCase() || ''
                const nameNoTone = this.removeVietnameseTones(item.Name || '')

                // --- Logic mới để kiểm tra tìm kiếm chữ cái đầu ---
                const firstLettersOfUnsignedName = unsigned.split(' ').map(word => word[0]).join(''); // 'sonoivu' -> 's', 'n', 'v' -> 'snv' (ví dụ với "so noi vu")
                const firstLettersOfNameNoTone = nameNoTone.split(' ').map(word => word[0]).join(''); // 'so noi vu' -> 's', 'n', 'v' -> 'snv'

                // Sửa đổi logic để handle "SONOIVU" -> "SNV"
                // Đối với "SONOIVU" trong UnsignedName, nó không có khoảng trắng,
                // nên ta cần kiểm tra nếu q khớp với chuỗi đó.
                // Hoặc kiểm tra xem q có phải là viết tắt của từng chữ cái đầu không.

                // Kiểm tra xem q có phải là viết tắt của chuỗi không dấu từ Name
                const isAcronymMatchName = (nameNoTone.split(' ')
                    .map(word => word[0])
                    .join('') === q);

                // Kiểm tra xem q có phải là viết tắt của chuỗi UnsignedName không (nếu nó không có khoảng trắng)
                // Ví dụ: 'SONOIVU' so với 'SNV'
                const isAcronymMatchUnsigned = (unsigned.split(' ') // nếu có khoảng trắng (ví dụ "so noi vu")
                    .map(word => word[0])
                    .join('') === q) ||
                    (unsigned === q) || // nếu q là toàn bộ unsigned (ví dụ: 'SONOIVU' tìm 'sonoivu')
                    (unsigned.split('').filter(char => q.includes(char)).length === q.length && unsigned.length > q.length && q.length > 1); // logic bổ sung cho viết tắt liền mạch
                // ^ Dòng này cần được tinh chỉnh cẩn thận nếu muốn bắt được "SNV" từ "SONOIVU" mà không cần "SONOIVU" có khoảng trắng.
                // Một cách đơn giản hơn là kiểm tra xem q có phải là chữ cái đầu của unsigned không.

                // Đơn giản hóa logic kiểm tra chữ cái đầu:
                // Tạo một hàm trợ giúp để kiểm tra viết tắt
                const checkAcronym = (fullString, searchQ) => {
                    if (!fullString || !searchQ) return false;
                    const fullStringNoSpace = fullString.replace(/\s/g, ''); // loại bỏ khoảng trắng để xử lý "SONOIVU" hoặc "Sở Nội Vụ"
                    // Nếu searchQ là viết tắt (chỉ chứa các ký tự đầu tiên của mỗi từ)
                    // hoặc searchQ là một chuỗi con của fullStringNoSpace
                    return fullStringNoSpace.includes(searchQ) ||
                        (searchQ.split('').every(char => fullStringNoSpace.includes(char)) && // mọi ký tự của q đều có trong fullStringNoSpace
                            fullStringNoSpace.length >= searchQ.length &&
                            searchQ.length > 0 &&
                            searchQ.split('').every((char, index) => { // và chúng xuất hiện theo đúng thứ tự
                                const firstCharIndex = fullStringNoSpace.indexOf(char);
                                if (index === 0) return firstCharIndex !== -1;
                                const prevChar = searchQ[index - 1];
                                const prevCharLastIndex = fullStringNoSpace.indexOf(prevChar); // index của ký tự trước đó
                                return fullStringNoSpace.indexOf(char, prevCharLastIndex + 1) !== -1;
                            }));
                };

                // Hàm kiểm tra viết tắt chính xác hơn, phù hợp cho "SONOIVU" -> "SNV"
                const isAcronym = (targetString, query) => {
                    if (!targetString || !query) return false;
                    const targetNoSpace = targetString.replace(/\s/g, '').toLowerCase(); // "sonoivu"
                    const queryLower = query.toLowerCase(); // "snv"

                    let targetIndex = 0;
                    for (let i = 0; i < queryLower.length; i++) {
                        const charToFind = queryLower[i];
                        let foundChar = false;
                        for (let j = targetIndex; j < targetNoSpace.length; j++) {
                            if (targetNoSpace[j] === charToFind) {
                                targetIndex = j + 1;
                                foundChar = true;
                                break;
                            }
                        }
                        if (!foundChar) {
                            return false; // Ký tự không được tìm thấy hoặc không đúng thứ tự
                        }
                    }
                    return true;
                };


                return (
                    nameNoTone.includes(q) ||       // Tìm kiếm "so noi vu" trong "So Noi Vu" -> TRUE
                    unsigned.includes(q) ||         // Tìm kiếm "so noi vu" trong "sonoivu" -> TRUE
                    url.includes(q) ||              // Tìm kiếm "so noi vu" trong "sonoivu.dongthap.gov.vn" -> TRUE

                    // Các điều kiện mới cho viết tắt:
                    isAcronym(nameNoTone, q) ||     // Tìm kiếm "snv" trong "So Noi Vu" -> FALSE (vì "So Noi Vu" có khoảng trắng)
                    isAcronym(unsigned, q)          // Tìm kiếm "snv" trong "SONOIVU" -> TRUE
                );
            })
        },
        // Tải dữ liệu cho các tab
        async loadData() {
            for (const tab of this.tabs) { //
                const data = await tab.dataSource(); //
                this.tabData = {
                    ...this.tabData,
                    [tab.key]: data
                };
            }
        },
        // Thay đổi tab
        changeTab(key) {
            this.activeTab = key;
            this.currentPage = 1; // Reset về trang 1 khi đổi tab
        },
    },
    mounted() {
        this.loadData();
        this.UBNDData = Data.UBNDData(); //
    }
}
</script>
